<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('operateDataLog.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-search-fields">
            <el-date-picker v-model="operateDataLogInfo.conditions.logStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('operateDataLog.search.logStartTime')" size="small" class="figma-date-picker" />
            <el-date-picker v-model="operateDataLogInfo.conditions.logEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('operateDataLog.search.logEndTime')" size="small" class="figma-date-picker" :picker-options="endDateOptions" />
            <el-input v-model="operateDataLogInfo.conditions.staffNameLike"
              :placeholder="$t('operateDataLog.search.staffNameLike')" size="small" class="figma-search-input-small" clearable />
          </div>
          <div class="figma-search-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_resetDataMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
            <el-button size="small" class="figma-btn-search" @click="_queryDataMethod">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </div>
        </div>

        <!-- 更多搜索条件 -->
        <div class="figma-search-more" v-show="operateDataLogInfo.moreCondition">
          <el-input v-model="operateDataLogInfo.conditions.feeNameLike"
            :placeholder="$t('operateDataLog.search.feeNameLike')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'feeConfigDetailHis' || operateDataLogInfo._currentTab === 'feeDetailHis'" />
          <el-input v-model="operateDataLogInfo.conditions.payerObjName"
            :placeholder="$t('operateDataLog.search.payerObjName')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'feeDetailHis'" />
          <el-input v-model="operateDataLogInfo.conditions.ownerNameLike"
            :placeholder="$t('operateDataLog.search.ownerNameLike')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'ownerDetailHis'" />
          <el-input v-model="operateDataLogInfo.conditions.roomName"
            :placeholder="$t('operateDataLog.search.roomName')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'roomDetailHis'" />
          <el-input v-model="operateDataLogInfo.conditions.carNumLike"
            :placeholder="$t('operateDataLog.search.carNumLike')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'carDetailHis'" />
          <el-input v-model="operateDataLogInfo.conditions.contractCode"
            :placeholder="$t('operateDataLog.search.contractCode')" size="small" class="figma-search-input-small" clearable
            v-if="operateDataLogInfo._currentTab === 'contractDetailChange'" />
        </div>

        <div class="figma-more-toggle" @click="_moreCondition">
          {{ operateDataLogInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
          <i :class="operateDataLogInfo.moreCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </div>

      <!-- Tab 切换 -->
      <div class="figma-tabs-bar">
        <button v-for="tab in tabs" :key="tab.name"
          :class="['figma-tab-btn', operateDataLogInfo._currentTab === tab.name ? 'figma-tab-btn-active' : '']"
          @click="changeTab(tab.name)">
          {{ tab.label }}
        </button>
      </div>

      <div class="figma-table-section">
        <component :is="currentComponent" :ref="currentComponent"></component>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import FeeConfigDetailHis from '@/components/system/feeConfigDetailHis'
import FeeDetailHis from '@/components/fee/feeDetailHis'
import OwnerDetailHis from '@/components/owner/ownerDetailHis'
import RoomDetailHis from '@/components/system/roomDetailHis'
import CarDetailHis from '@/components/system/carDetailHis'
import ContractDetailChange from '@/components/system/contractDetailChange'

export default {
  name: 'OperateDataLogList',
  components: {
    FeeConfigDetailHis,
    FeeDetailHis,
    OwnerDetailHis,
    RoomDetailHis,
    CarDetailHis,
    ContractDetailChange
  },
  data() {
    return {
      communityId: '',
      tabs: [
        { name: 'feeConfigDetailHis', label: '费用项' },
        { name: 'feeDetailHis', label: '费用' },
        { name: 'ownerDetailHis', label: '业主' },
        { name: 'roomDetailHis', label: '房屋' },
        { name: 'carDetailHis', label: '车辆' },
        { name: 'contractDetailChange', label: '合同' }
      ],
      operateDataLogInfo: {
        _currentTab: 'feeConfigDetailHis',
        moreCondition: false,
        conditions: {
          logStartTime: '',
          logEndTime: '',
          staffNameLike: '',
          feeNameLike: '',
          payerObjName: '',
          ownerNameLike: '',
          roomName: '',
          carNumLike: '',
          contractCode: ''
        }
      },
      endDateOptions: {
        disabledDate: (time) => {
          if (this.operateDataLogInfo.conditions.logStartTime) {
            return time.getTime() <= new Date(this.operateDataLogInfo.conditions.logStartTime).getTime()
          }
          return false
        }
      }
    }
  },
  computed: {
    currentComponent() {
      return this.operateDataLogInfo._currentTab
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.changeTab(this.operateDataLogInfo._currentTab)
  },
  methods: {
    changeTab(tab) {
      this.operateDataLogInfo._currentTab = tab
      setTimeout(() => {
        if (tab === 'ownerDetailHis') {
          this.$refs[tab].open('', '', '', this.operateDataLogInfo.conditions.logStartTime, this.operateDataLogInfo.conditions.logEndTime, this.operateDataLogInfo.conditions.staffNameLike)
          return
        }
        if (this.$refs[tab]) {
          this.$refs[tab].open(this.operateDataLogInfo.conditions)
        }
      }, 100)
    },
    _queryDataMethod() {
      this.changeTab(this.operateDataLogInfo._currentTab)
    },
    _resetDataMethod() {
      this.operateDataLogInfo.conditions = {
        logStartTime: '',
        logEndTime: '',
        staffNameLike: '',
        feeNameLike: '',
        payerObjName: '',
        ownerNameLike: '',
        roomName: '',
        carNumLike: '',
        contractCode: ''
      }
      this.changeTab(this.operateDataLogInfo._currentTab)
    },
    _moreCondition() {
      this.operateDataLogInfo.moreCondition = !this.operateDataLogInfo.moreCondition
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 0; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 0; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; flex-wrap: wrap; gap: 12px; }
.figma-search-fields { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.figma-date-picker { width: 200px; }
.figma-date-picker >>> .el-input__inner { border-radius: 10px; border: 1px solid #DCE6F5; height: 38px; }
.figma-search-input-small { width: 180px; }
.figma-search-input-small >>> .el-input__inner { border-radius: 10px; border: 1px solid #DCE6F5; height: 38px; }
.figma-search-group { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-btn-search { height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-search-more { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; width: 100%; }
.figma-more-toggle { color: #0E76FF; font-size: 14px; cursor: pointer; display: flex; align-items: center; gap: 4px; user-select: none; }
.figma-more-toggle:hover { text-decoration: underline; }
.figma-tabs-bar { display: flex; gap: 8px; padding: 0 24px; border-bottom: 1px solid #DCE6F5; }
.figma-tab-btn { padding: 10px 20px; border: none; background: none; color: #6A7282; font-size: 14px; font-weight: 500; cursor: pointer; border-bottom: 2px solid transparent; transition: all 0.2s; margin-bottom: -1px; }
.figma-tab-btn:hover { color: #0E76FF; }
.figma-tab-btn-active { color: #0E76FF !important; border-bottom-color: #0E76FF !important; }
.figma-table-section { flex: 1; padding: 16px 24px; overflow: auto; }
</style>
